import React, { Component } from 'react';
import appstore from '../assets/img/app-stores.svg';
import disocs from '../assets/img/discos.svg';
import yc from '../assets/img/YC.svg';
import banksxtelcos from '../assets/img/banksxtelcos.svg';
import tokens from '../assets/img/tokens.svg';

class About extends Component {
  render() {
    return (
      <div className="aboutContainer">
        <div className="about__header">
          <div className="about__header__typography">Convenience at your fingertips</div>
        </div>
        <div className="about__mission">
          {/* <div className="about__mission--img"></div> */}
          <div>
            <span className="about__bar"></span>
            <div className="about__typography--heading">Our Mission</div>
            <div className="about__mission--text">Our mission is to simplify utility payments and enable energy access in Africa.</div>
          </div>
          
        </div>
        <div className="about__whatwedo">
          <span className="about__bar"></span>
          <div className="about__typography--heading">What we do</div>
          <div className="about__whatwedo__main">
            <div className="about__whatwedo__main--img"></div>
            <div className="about__whatwedo--text">
              BuyPower lets you pay for your electricity bills online, from the comfort of your homes and offices. The platform has simplified 
              the process that comes with paying for utilities and has integrated tools and features to help you manage as well as conserve these utilities. <br/><br />
              We work round the clock everyday, to ensure our customers get maximum value and added services for their purchases.
            </div>
          </div>
        </div>
        <div className="about__purpose">
          <span className="about__bar"></span>
          <div className="about__typography--heading">Our Purpose</div>
          <div className="about__purpose--text">
            Once, people didn't have end-to-end control over their utilities. Right from choosing service providers, to paying utility bills 
            and subsequently, maximizing value received.
            <br/><br/>
            We figured that this was an ordinary way to live, which is why we decided to do the 
            extraordinary: Create a platform that lets you pay bills and maximize value gotten from service providers.
          </div>
        </div>
        <div className="about__milestones">
          <div className="about__milestones--top">
            <span className="about__bar"></span>
            <div className="about__typography--heading">Milestones</div>
          </div>
          <div className="about__milestones--bottom">
            <div className="about__milestones--stones">
              <div className="about__milestones--display">
                <div><img className="about__milestones--img"src={appstore} alt="appStores"/></div>
                <div>Average of 4.5 rating on respective App Stores with over 6k Reviews</div>
              </div>
              <div className="about__milestones--display">
                <div><img className="about__milestones--img"src={disocs} alt="discos"/></div>
                <div>Currently covers 9 electricity distribution companies in Nigeria.</div>
              </div>
              <div className="about__milestones--display">
                <div><img className="about__milestones--img"src={yc} alt="ycombinators"/></div>
                <div>Raised seed round from  YCombinator & other Venture Investors</div>
              </div>
              <div className="about__milestones--display">
                <div><img className="about__milestones--img"src={banksxtelcos} alt="banksxtelcos"/></div>
                <div>Partnerships with leading Fintechs, Banks and Telcommunication companies </div>
              </div>
              <div className="about__milestones--display">
                <div><img className="about__milestones--img"src={tokens} alt="tokens"/></div>
                <div>Over 100 Million tokens generated for users.</div>
              </div>
            </div>
          </div>
        </div>
        <div className="about__platform">
          <div className="about__platform--left">
            <span className="about__bar"></span>
            <div className="about__typography--heading">Our Platform</div>
            <div className="about__platform--text">
              BuyPower’s vast platform is a combination of individually unique products that aims to bring convenience to utility payments in as many ways as possible. 
            </div>
          </div>
          <div className="about__platform--right">
            <div>
              <div className="platform--right--header">BuyPower.ng</div>
              <div className="platform--right--text">
                The fastest platform to pay your electricity bills online. You can buy electricity with a loan and pay back in 14 days.
              </div>
              {/* <div className="platform--right--link">Learn More</div> */}
            </div>
            <div>
              <div className="platform--right--header">Vending System</div>
              <div className="platform--right--text">
                BuyPower offers extra convenience by providing a vending system for private estates and communities to manage their meters.
              </div>
              {/* <div className="platform--right--link">Learn More</div> */}
            </div>
            <div>
              <div className="platform--right--header">BuyPower Mobile App</div>
              <div className="platform--right--text">
                Available on the Google Play Store and iOS App Store. Paying your electricity bills comes with a different kind of ease
              </div>
              {/* <div className="platform--right--link">Learn More</div> */}
            </div>
            <div>
              <div className="platform--right--header">BuyPower Merchant</div>
              <div className="platform--right--text">
                With a commission on every sale, BuyPower’s Merchant program offers you a profitable business venture.
              </div>
              {/* <div className="platform--right--link">Learn More</div> */}
            </div>
          </div>
        </div>
        <div className="about__header">
          <div className="about__header__typography">“Ordinary is boring!”</div>
        </div>
      </div>
    );
  }
}

export default About;



// WEBPACK FOOTER //
// ./src/components/About.js